var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDot2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6663 14.6667C20.6663 17.244 18.577 19.3333 15.9997 19.3333C13.4223 19.3333 11.333 17.244 11.333 14.6667C11.333 12.0893 13.4223 10 15.9997 10C18.577 10 20.6663 12.0893 20.6663 14.6667Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.6665C22.4941 2.6665 28 8.04381 28 14.5676C28 21.1952 22.4044 25.8461 17.236 29.0088C16.8593 29.2214 16.4333 29.3332 16 29.3332C15.5667 29.3332 15.1407 29.2214 14.764 29.0088C9.6052 25.8153 4 21.2181 4 14.5676C4 8.04381 9.50592 2.6665 16 2.6665Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDot2);
export default __webpack_public_path__ + "static/media/location-dot2.e6dd9cf4d3e3d5912d3cdc4dbf486605.svg";
export { ForwardRef as ReactComponent };